import axios from '../../config/axiosConfig';
import { CREATE_COMPANY, UPDATE_COMPANY, GET_COMPANIES, COMPANY_REQUEST, COMPANY_REQUEST_FAILURE, SET_COMPANY,
    DELETE_COMPANY, SET_USER_AUTHORIZE_COMPANIES, SUCCESS_COMPANY } from '../types';
import { getLinkedFinyearCompanies } from './link-finyear-company-actions';

export const getCompanies = () => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: COMPANY_REQUEST });
            return axios.get('/company/getAll', { params: { customerId: auth?.user?.Customer_Id }}).then((response) => {
              if (response.data) {
                dispatch({ type: GET_COMPANIES, payload: response.data });
              }
            }).catch((error) => {
              console.error(error);
              dispatch({ type: COMPANY_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: COMPANY_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const getUserAuthorizeCompanies = (userId) => {
    return async (dispatch, getState) => {
      try {
        dispatch({ type: COMPANY_REQUEST });
        const { auth } = getState();
        return axios.get("/authorizeCompany/getAll", { params: { customerId: auth?.user?.Customer_Id, userId: auth?.user?.id }}).then((response) => {
          if (response.data) {
            dispatch({ type: SET_USER_AUTHORIZE_COMPANIES, payload: response.data });
          }
        }).catch((error) => {
          console.error(error);
          dispatch({ type: COMPANY_REQUEST_FAILURE, error: error.message });  
        });
      } catch (error) {
        console.error(error);
        dispatch({ type: COMPANY_REQUEST_FAILURE, error: error.message });
      }
    }
  }

export const createCompany = (company) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: COMPANY_REQUEST });
            const newCompany = {
                ...company,
                Fin_Year_Id: auth.finyear?.id,
                Created_User: auth.user?.id,
                Modified_User: auth.user?.id
            };
            return axios.post('/company/add', newCompany,
                { params: { userId: auth.user?.id, customerId: auth?.user?.Customer_Id }}
              ).then((response) => {
                if (response.data) {
                  dispatch({ type: CREATE_COMPANY, payload: response.data });
                  if (!auth.company?.id) {
                      dispatch({ type: SET_COMPANY, payload: response.data });
                  }
                  dispatch(getLinkedFinyearCompanies());
                  dispatch(getUserAuthorizeCompanies(auth.user?.id));
                } else {
                    dispatch({ type: COMPANY_REQUEST_FAILURE, error: 'Company create failed.' });
                }
                return response;
              }).catch((error) => {
                console.error(error);
                dispatch({ type: COMPANY_REQUEST_FAILURE, error: error.message });
                throw error;
              });
        } catch (error) {
            console.error(error);
            dispatch({ type: COMPANY_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateCompany = (id, data) => {
    return async (dispatch, getState) => {
      try {
        dispatch({ type: COMPANY_REQUEST });
        const { auth } = getState();
        return axios.put("/company/update", { id, data },
          { params: { userId: auth.user?.id }}).then((response) => {
            if (response.data) {
              dispatch({
                type: UPDATE_COMPANY,
                payload: { id, data: response.data },
              });
              if (auth.company?.id == id) {
                dispatch({ type: SET_COMPANY, payload: response.data });
              }
            } else {
              dispatch({
                type: COMPANY_REQUEST_FAILURE,
                error: "Company update failed.",
              });
            }
            return response;
          }).catch((error) => {
            console.error(error);
            dispatch({ type: COMPANY_REQUEST_FAILURE, error: error.message });
            throw error;
          });
      } catch (error) {
        console.error(error);
        dispatch({ type: COMPANY_REQUEST_FAILURE, error: error.message });
        throw error;
      }
    };
  };

  export const deleteCompany = (id) => {
    return async (dispatch) => {
      try {
        dispatch({ type: COMPANY_REQUEST });
        return axios.delete(`/company/delete/${id}`).then((response) => {
          if (response.data) {
            dispatch({ type: DELETE_COMPANY, id: id });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: COMPANY_REQUEST_FAILURE, error: error.message });
          throw error;
        });
      } catch (error) {
        console.error(error);
        dispatch({ type: COMPANY_REQUEST_FAILURE, error: error.message });
        throw error;
      }
    };
  };

  export const getCompanyLogos = (companyId) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: COMPANY_REQUEST });
            return axios.get('/company/getLogos', { params: { companyId: companyId }}).then((response) => {
              if (response) {  
                dispatch({ type: SUCCESS_COMPANY });
                return response?.data;

              }
            }).catch((error) => {
              console.error(error);
              dispatch({ type: COMPANY_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: COMPANY_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const getCustomerVerifiedWhatsapp = () => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: COMPANY_REQUEST });
            return axios.get('/company/getCustomerVerifiedWhatsapp', { params: { customerId: auth.customer?.id }}).then((response) => {
              if (response) {  
                dispatch({ type: SUCCESS_COMPANY });
                return response?.data;

              }
            }).catch((error) => {
              console.error(error);
              dispatch({ type: COMPANY_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: COMPANY_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const getCompanyMailSmtps = (companyId) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: COMPANY_REQUEST });
            return axios.get('/company/getMailSmtps', { params: { companyId: auth.company?.id }}).then((response) => {
              if (response) {  
                dispatch({ type: SUCCESS_COMPANY });
                return response?.data;

              }
            }).catch((error) => {
              console.error(error);
              dispatch({ type: COMPANY_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: COMPANY_REQUEST_FAILURE, error: error.message });
        }
    };
};